import axios from 'axios';
import { Snippet } from './snippet';

export interface SnippetIndexFilters {
  key_cont: string;
}

export interface SnippetIndexOptions {
  itemsPerPage: number;
  sortBy: string[];
  sortDesc: boolean[];
  page: number;
  filters: SnippetIndexFilters;
}

export class SnippetIndex {
  public static PER_PAGE: number = 30;

  public static async getCount(
    filters?: SnippetIndexFilters,
  ): Promise<any> {
    return axios.get('/api/snippets/count', {
      params: {
        filters,
      },
    });
  }

  public static async getData(
    snippetIndexOptions?: SnippetIndexOptions,
  ): Promise<any> {
    if (snippetIndexOptions == null) {
      return axios.get('/api/snippets', {
        params: {
          per_page: this.PER_PAGE,
        },
      });
    }

    const perPage =
      snippetIndexOptions.itemsPerPage <= 0
        ? this.PER_PAGE
        : snippetIndexOptions.itemsPerPage;
    return axios.get('/api/snippets', {
      params: {
        per_page: perPage,
        sort_fields: snippetIndexOptions.sortBy,
        sort_desc: snippetIndexOptions.sortDesc,
        page: snippetIndexOptions.page,
        filters: snippetIndexOptions.filters,
      },
    });
  }

  public static parseResponse(response: any): Snippet[] {
    const snippetData = [] as Snippet[];
    for (const k in response) {
      if (!response[k]) {
        continue;
      }
      const item = response[k];
      const snippet = {} as Snippet;
      snippet.id = item.id;
      snippet.key = item.key;
      snippet.content = item.content;
      snippet.updatedAt = new Date(item.updated_at);
      snippetData.push(snippet);
    }
    return snippetData;
  }
}
